import { createClient } from "@supabase/supabase-js"
import { env } from "@/lib/env"

export const supabase = env.demoMode
  ? null
  : createClient(env.supabaseUrl, env.supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
